"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HistoryItemType;
(function (HistoryItemType) {
    HistoryItemType["NextDeliveryDate"] = "nextDeliveryDate";
    HistoryItemType["DayOfDelivery"] = "dayOfDelivery";
    HistoryItemType["SeriesStatus"] = "seriesStatus";
    HistoryItemType["DoctorId"] = "doctorId";
    HistoryItemType["Annotation"] = "annotation";
    HistoryItemType["PharmacyId"] = "pharmacyId";
    HistoryItemType["TherapyTypeId"] = "therapyTypeId";
    HistoryItemType["StandardCareProposalId"] = "standardCareProposalId";
    HistoryItemType["ProposedArticleLines"] = "proposedArticleLines";
    HistoryItemType["SeriesData"] = "seriesData";
    HistoryItemType["DeliveryAddress"] = "deliveryAddress";
    HistoryItemType["DeliveryInformation"] = "deliveryInformation";
    HistoryItemType["DeliveryStartTime"] = "deliveryStartTime";
    HistoryItemType["DeliveryNote"] = "deliveryNote";
    HistoryItemType["Status"] = "status";
})(HistoryItemType = exports.HistoryItemType || (exports.HistoryItemType = {}));
exports.default = HistoryItemType;
